import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const CACHE_KEY = 'ecoplanner_drivers_v1';
const CACHE_TTL = 10 * 60 * 1000; // 10 minutos

function loadCached() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return [];
    const { data, ts } = JSON.parse(raw);
    if (Date.now() - ts > CACHE_TTL) return [];
    return data;
  } catch { return []; }
}

function saveCache(data) {
  try { localStorage.setItem(CACHE_KEY, JSON.stringify({ data, ts: Date.now() })); } catch { /* ignore */ }
}

const MOCK_DRIVERS = [
  { id: 'd1', name: 'António Silva', licenseClass: 'C+E', tachoCard: 'PT123456', phone: '+351912345678' },
  { id: 'd2', name: 'Manuel Costa', licenseClass: 'C', tachoCard: 'PT234567', phone: '+351923456789' },
  { id: 'd3', name: 'João Ferreira', licenseClass: 'C+E', tachoCard: 'PT345678', phone: '+351934567890' },
  { id: 'd4', name: 'Pedro Santos', licenseClass: 'C', tachoCard: 'PT456789', phone: '+351945678901' },
  { id: 'd5', name: 'Carlos Oliveira', licenseClass: 'C+E', tachoCard: 'PT567890', phone: '+351956789012' },
];

export const fetchDrivers = createAsyncThunk("drivers/fetch", async (token) => {
  const res = await fetch("/planner-api/drivers", {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Failed to fetch drivers");
  return res.json();
});

export const createDriver = createAsyncThunk("drivers/create", async ({ token, data }) => {
  const res = await fetch("/planner-api/drivers", {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  const result = await res.json();
  if (!res.ok) throw new Error(result.error || "Erro ao criar motorista");
  return result;
});

export const updateDriver = createAsyncThunk("drivers/update", async ({ token, id, data }) => {
  const res = await fetch(`/planner-api/drivers/${id}`, {
    method: "PUT",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  const result = await res.json();
  if (!res.ok) throw new Error(result.error || "Erro ao atualizar motorista");
  return result;
});

export const deleteDriver = createAsyncThunk("drivers/delete", async ({ token, id }) => {
  const res = await fetch(`/planner-api/drivers/${id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    const result = await res.json();
    throw new Error(result.error || "Erro ao eliminar motorista");
  }
  return id;
});

const driversSlice = createSlice({
  name: "drivers",
  initialState: { list: loadCached(), loading: false },
  reducers: {
    loadMockDrivers: (state) => {
      state.list = MOCK_DRIVERS;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDrivers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDrivers.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading = false;
        saveCache(action.payload);
      })
      .addCase(fetchDrivers.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createDriver.fulfilled, (state, action) => {
        state.list.push(action.payload);
      })
      .addCase(updateDriver.fulfilled, (state, action) => {
        const idx = state.list.findIndex((d) => d.id === action.payload.id);
        if (idx >= 0) state.list[idx] = action.payload;
      })
      .addCase(deleteDriver.fulfilled, (state, action) => {
        state.list = state.list.filter((d) => d.id !== action.payload);
      });
  },
});

export const { loadMockDrivers } = driversSlice.actions;
export const selectDrivers = (state) => state.drivers.list;
export const selectDriverById = (id) => (state) =>
  state.drivers.list.find((d) => d.id === id);
export default driversSlice.reducer;
